exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ToggleablePanel-toggleablePanel-33h48{position:relative}.ToggleablePanel-toggleablePanel-33h48 .ToggleablePanel-header-2kuPQ{margin-left:1em;display:-ms-flexbox;display:flex}.ToggleablePanel-toggleablePanel-33h48 .ToggleablePanel-header-2kuPQ *{display:inline-block;margin:0}.ToggleablePanel-toggleablePanel-33h48 *{margin:0}.ToggleablePanel-toggleablePanel-33h48.ToggleablePanel-expandable-1hiUZ,.ToggleablePanel-toggleablePanel-33h48.ToggleablePanel-expandable-1hiUZ *{cursor:pointer}.ToggleablePanel-toggleablePanel-33h48 .ToggleablePanel-arrow-1qo_J{position:absolute;top:0;left:0;display:inline-block;transition:transform .2s ease 0s}.ToggleablePanel-toggleablePanel-33h48.ToggleablePanel-expanded-1GalI .ToggleablePanel-arrow-1qo_J{transform:rotate(90deg)}", ""]);

// exports
exports.locals = {
	"toggleablePanel": "ToggleablePanel-toggleablePanel-33h48",
	"header": "ToggleablePanel-header-2kuPQ",
	"expandable": "ToggleablePanel-expandable-1hiUZ",
	"arrow": "ToggleablePanel-arrow-1qo_J",
	"expanded": "ToggleablePanel-expanded-1GalI"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/ToggleablePanel.less
// module id = 1666
// module chunks = 0